<div class='authentication-layout-container'>
  <img class='img-logo-cbp' src='assets/logo-CBP.png' alt='CBP Logo' data-cy="cbp-logo" />
  <ng-content></ng-content>
</div>
